/* eslint-disable comma-spacing */
/* eslint-disable no-param-reassign */
/* eslint-disable no-sequences */
/* eslint-disable no-return-assign */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import {
  Form,
  Row,
  Spin,
  Col,
  Modal,
  Input,
} from 'antd';
import Table from 'components/Table';

import React, { useState, useEffect } from 'react';
import { checkToken } from 'api/utils';
import Select from 'components/Select';
import FormSubmitControls from 'components/FormSubmitControls';
import { formatReceivedValues } from 'utils/formatValues';
import { getEmpleadosFiltered } from 'api/estructuraOrganizacional/empleados';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getPlazas } from 'api/catalogos/plazas';
import { getAreas } from 'api/catalogos';
import { getPuestos } from 'api/catalogos/puestos';
import { getBancos } from 'api/configuraciones';
import { getTiposDeDepositos } from 'api/catalogos/tiposDeDepositos';
import {
  getDatoDePagoDelEmpleado,
  getDatosDePagoDeEmpleados,
  patchDatoDePagoDelEmpleado,
  postDatoDePagoDelEmpleado,
  putDatoDePagoDelEmpleado,
} from 'api/estructuraOrganizacional/datosDePagoDeEmpleados';
import { getAdministracionDePlazas } from 'api/catalogos/admnistracionDePlazas';
import { areaBuscar, normalizeData } from 'utils/normalizers';
import { onError, onSuccess } from 'utils/handlers';
import moment from 'moment';
import ModalLimpiar from 'components/ModalLimpiar';
import ModalDeactivate from 'components/ModalDeactivate';
import {
  ESTATUS_ACTIVO, ESTATUS_INACTIVO,
  METODO_DE_PAGO_TRANSFERENCIA_ELECTRONICA_DE_FONDOS,
  TIPO_DE_DEPOSITO_CLABE,
  TIPO_DE_DEPOSITO_DEBITO,
  ESTADO_ACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';

export const administracionDeTarjetasDePagoPermission = {
  permissionModel: 'datodepagodelempleado',
  catalogsModels: [],
  tabsModels: [],
};

const AdministracionDeTarjetasDePago = ({ permission }) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openDeactivate, setOpenDeactivate] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [deshabilitarCLABE, setDeshabilitarCLABE] = useState(false);
  const [validateStatusCLABE, setValidateStatusCLABE] = useState('');
  const [deshabilitarNoCuenta, setDeshabilitarNoCuenta] = useState(false);
  const [validateStatusNoCuenta, setValidateStatusNoCuenta] = useState('');

  const [areas, setAreas] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [tiposDeDepositos, setTiposDeDepositos] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [administracionDePlazas, setAdministracionDePlazas] = useState([]);
  const [tiposDeNominasEmpleados, setTiposDeNominasEmpleados] = useState([]);
  const [datosDePagosDeEmpleados, setDatosDePagosDeEmpleados] = useState([]);
  const [datosOperacionalesEmpleados, setDatosOperacionalesEmpleados] = useState([]);

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        empleadoTipoNomina: e?.empleado,
        empleadoNombre: e?.empleado,
        empleadoRFC: e?.empleado,
        empleadoArea: e?.empleado,
        empleadoPuesto: e?.empleado,
        empleadoPlaza: e?.empleado,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const fetchData = async () => {
    setLoading(true);
    const _datosDePagosDeEmpleados = await getDatosDePagoDeEmpleados();
    let _datosDePagoEmpleadosFiltered = formatReceivedClone(_datosDePagosDeEmpleados).filter((datoDePagoEmpleado) => datoDePagoEmpleado?.metodo_de_pago === METODO_DE_PAGO_TRANSFERENCIA_ELECTRONICA_DE_FONDOS && datoDePagoEmpleado?.estados_globales === ESTATUS_ACTIVO);

    const _isActive = empleados.filter((empleado) => empleado.estado_del_empleado === ESTADO_ACTIVO);
    const _empleadosIds = _isActive.map(({ id }) => id);
    _datosDePagoEmpleadosFiltered = _datosDePagoEmpleadosFiltered.filter((dato) => _empleadosIds.includes(dato.empleado));
    setDatosDePagosDeEmpleados(_datosDePagoEmpleadosFiltered);
    setLoading(false);
  };

  useEffect(() => {
    // Si hay un elemento seleccionado: Mostrar nombre del registro al eliminar.
    // Si hay más de un elemento seleccionado: Mostrar "n" cantidad de elementos al eliminar.
    setDeleteMessage(selectedRowKeys.length > 0 ? selectedRowKeys.length : '');
  }, [selectedRowKeys]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _datosDePagosDeEmpleados,
        _empleados,
        _datosOperacionalesEmpleados,
        _tiposDeNominasEmpleados,
        _administracionDePlazas,
        _plazas,
        _areas,
        _puesto,
        _bancos,
        _tiposDeDepositos,
      ] = await Promise.all([
        getDatosDePagoDeEmpleados(),
        getEmpleadosFiltered(),
        getDatoOperacionalesDeEmpleados(),
        getTiposDeNominasEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
        getAdministracionDePlazas(),
        getPlazas(),
        getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        getPuestos(),
        getBancos(),
        getTiposDeDepositos(),
      ]);

      if (mounted) {
        let _datosDePagoEmpleadosFiltered = formatReceivedClone(_datosDePagosDeEmpleados).filter((datoDePagoEmpleado) => datoDePagoEmpleado.metodo_de_pago === 3 && datoDePagoEmpleado.estados_globales === ESTATUS_ACTIVO);

        //! Filtro para descartar datos de pago de empleados eliminados y visualizar solo empleados activos
        const _isActive = _empleados.filter((empleado) => empleado.estado_del_empleado === ESTADO_ACTIVO);
        const _empleadosIds = _isActive.map(({ id }) => id);
        _datosDePagoEmpleadosFiltered = _datosDePagoEmpleadosFiltered.filter((dato) => _empleadosIds.includes(dato.empleado));

        setDatosDePagosDeEmpleados(_datosDePagoEmpleadosFiltered);
        setEmpleados(_empleados);
        setDatosOperacionalesEmpleados(_datosOperacionalesEmpleados);
        setTiposDeNominasEmpleados(_tiposDeNominasEmpleados);
        setAdministracionDePlazas(_administracionDePlazas);
        setPlazas(_plazas);
        // setAreas(_areas);
        setAreas(normalizeData(_areas));
        setPuestos(_puesto);
        setBancos(_bancos);
        setTiposDeDepositos(_tiposDeDepositos);
      }
      setLoading(false);
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const columns = [
    {
      key: 'empleado',
      dataIndex: 'empleado',
      titleText: 'No. de Empleado',
      width: 200,
      render: (id) => {
        const empleado = empleados.find((empleadoObject) => empleadoObject.id === id);
        return empleado?.numero_de_empleado || '';
      },
    },
    {
      key: 'empleadoTipoNomina',
      dataIndex: 'empleadoTipoNomina',
      titleText: 'Tipo de Nómina Empleado',
      width: 250,
      render: (id) => {
        const datoOperacional = datosOperacionalesEmpleados.find((datoOperacionalObject) => datoOperacionalObject.empleado === id);
        const tipoNominaEmpleado = tiposDeNominasEmpleados.find((tipoDeNominaEmpleadoObject) => tipoDeNominaEmpleadoObject.id === datoOperacional?.tipo_de_nomina_empleado);
        return tipoNominaEmpleado?.descripcion || '';
      },
    },
    {
      key: 'empleadoNombre',
      dataIndex: 'empleadoNombre',
      titleText: 'Nombre del Empleado',
      width: 200,
      render: (id) => {
        const empleado = empleados.find((empleadoObject) => empleadoObject.id === id);
        return `${empleado?.nombre || ''} ${empleado?.apellido_paterno || ''} ${empleado?.apellido_materno || ''}`;
      },
    },
    {
      key: 'empleadoRFC',
      dataIndex: 'empleadoRFC',
      titleText: 'RFC',
      width: 200,
      render: (id) => {
        const empleado = empleados.find((empleadoObject) => empleadoObject?.id === id);
        return empleado?.RFC || '';
      },
    },
    {
      key: 'empleadoArea',
      dataIndex: 'empleadoArea',
      titleText: 'Área',
      width: 200,
      render: (id) => {
        const administracionDePlaza = administracionDePlazas.find((administracionDePlazaObject) => administracionDePlazaObject?.empleado === id);
        const plaza = plazas.find((plazaObject) => plazaObject.id === administracionDePlaza?.plaza);
        const area = areaBuscar(plaza?.area_content_id, areas);
        return area?.tableTitle || '';
      },
    },
    {
      key: 'empleadoPuesto',
      dataIndex: 'empleadoPuesto',
      titleText: 'Puesto',
      width: 200,
      render: (id) => {
        const administracionDePlaza = administracionDePlazas.find((administracionDePlazaObject) => administracionDePlazaObject.empleado === id);
        const plaza = plazas.find((plazaObject) => plazaObject.id === administracionDePlaza?.plaza);
        const puesto = puestos.find((puestoObject) => puestoObject.id === plaza?.puesto);
        return puesto?.descripcion || '';
      },
    },
    {
      key: 'empleadoPlaza',
      dataIndex: 'empleadoPlaza',
      titleText: 'Plaza',
      width: 200,
      render: (id) => {
        const administracionDePlaza = administracionDePlazas.find((administracionDePlazaObject) => administracionDePlazaObject.empleado === id);
        const plaza = plazas.find((plazaObject) => plazaObject.id === administracionDePlaza?.plaza);
        return plaza?.clave || '';
      },
    },
    {
      key: 'tipos_de_depositos',
      dataIndex: 'tipos_de_depositos',
      titleText: 'Tipo de Depósito',
      width: 200,
      render: (tipo_deposito_id) => tiposDeDepositos.find((tipoDeposito) => tipoDeposito.id === tipo_deposito_id)?.concepto,
    },
    {
      key: 'banco',
      dataIndex: 'banco',
      titleText: 'Banco',
      width: 200,
      render: (id) => {
        const banco = bancos.find((bancoObject) => bancoObject.id === id);
        return banco?.nombre || '';
      },
    },
    {
      key: 'numero_tarjeta',
      dataIndex: 'numero_tarjeta',
      titleText: 'No. de Cuenta',
      width: 200,
      render: (numero) => {
        const numbers = numero?.match(/.{1,4}/g);
        return numbers ? `${numbers[0] || ''} ${numbers[1] || ''} ${numbers[2] || ''} ${numbers[3] || ''}` : '';
      },
    },
    {
      key: 'clabe',
      dataIndex: 'clabe',
      titleText: 'CLABE',
      width: 200,
      render: (clabe) => {
        return clabe || '';
      },
    },
  ];

  const onClickCancel = () => {
    setValidateStatusCLABE('');
    setValidateStatusNoCuenta('');
    setDeshabilitarNoCuenta(false);
    setDeshabilitarCLABE(false);

    setSelectedRowKeys([]);
    setOpen(false);
    form.resetFields();
  };

  const onClickDeactivate = async () => {
    setOpenDeactivate(true);
  };

  const onDeactivate = async () => {
    setLoading(true);
    try {
      const _valuesToDeactivate = datosDePagosDeEmpleados.filter((datoPagoEmpleado) => {
        if (selectedRowKeys.includes(datoPagoEmpleado.id)) {
          datoPagoEmpleado.estados_globales = ESTATUS_INACTIVO;
          datoPagoEmpleado.fecha_de_baja = moment().format('YYYY-MM-DD');
          return datoPagoEmpleado;
        }
        return null;
      });

      const _saved = await putDatoDePagoDelEmpleado(_valuesToDeactivate);

      if (_saved) {
        onSuccess(_saved, _valuesToDeactivate.length === 1 ? 'Desactivado correctamente.' : 'Desactivados correctamente.');
      }
      onClickCancel();

      setLoading(false);
      setOpenDeactivate(false);
      fetchData();
    } catch (error) {
      onError(error);
      setLoading(false);
    }
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);

    const [key] = selectedRowKeys;
    const match = responseData || datosDePagosDeEmpleados.find((item) => item.id === key);
    const _datoDePagoDeEmpleado = await getDatoDePagoDelEmpleado(match.id);

    setTimeout(() => {
      if (_datoDePagoDeEmpleado) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(_datoDePagoDeEmpleado);
          setOpen(true);
        });
      }
    });

    if (_datoDePagoDeEmpleado.numero_tarjeta === null && _datoDePagoDeEmpleado.clabe === null) {
      setDeshabilitarCLABE(true);
      setDeshabilitarNoCuenta(true);
    }

    if (_datoDePagoDeEmpleado?.numero_tarjeta?.length > 0) {
      setDeshabilitarCLABE(true);
    }

    if (_datoDePagoDeEmpleado?.clabe?.length > 0) {
      setDeshabilitarNoCuenta(true);
    }

    setLoading(false);
  };

  const onClickDelete = async () => {
    setOpenDelete(true);
  };

  const onDelete = async () => {
    setLoading(true);

    try {
      const _valuesToDelete = datosDePagosDeEmpleados.filter((datoDePagoEmpleado) => {
        if (selectedRowKeys.includes(datoDePagoEmpleado.id)) {
          datoDePagoEmpleado.tipos_de_depositos = null;
          datoDePagoEmpleado.banco = null;
          datoDePagoEmpleado.numero_tarjeta = null;
          datoDePagoEmpleado.clabe = null;
          datoDePagoEmpleado.fecha_de_baja = moment().format('YYYY-MM-DD');
          return datoDePagoEmpleado;
        }
        return null;
      });

      const _saved = await putDatoDePagoDelEmpleado(_valuesToDelete);

      if (_saved) {
        onSuccess(_saved ,_valuesToDelete.length === 1 ? 'Eliminado correctamente.' : 'Eliminados correctamente.');
      }

      onClickCancel();

      setLoading(false);
      setOpenDelete(false);
      fetchData();
    } catch (error) {
      onError(error);
      setLoading(false);
      setOpenDelete(false);
    }

    // try {
    //   await Promise.all(selectedRowKeys.map(async (key) => {
    //     const _datoPagoEmpleado = await getDatoDePagoDelEmpleado(key);

    //     _datoPagoEmpleado.banco = null;
    //     _datoPagoEmpleado.numero_tarjeta = null;
    //     _datoPagoEmpleado.clabe = null;

    //     await patchDatoDePagoDelEmpleado(_datoPagoEmpleado.id, _datoPagoEmpleado);
    //   }));
    //   setLoading(false);
    //   setOpenDelete(false);
    //   fetchData();
    // } catch (error) {
    //   onError(error);
    //   setLoading(false);
    //   setOpenDelete(false);
    // }
  };

  const inactivarFormasDePagosDelEmpleado = async (formasDePagosActivos) => {
    await Promise.all(formasDePagosActivos.map(async (formaDePago) => {
      formaDePago.estados_globales = 3; // ESTATUS_INACTIVO
      formaDePago.fecha_de_baja = moment().format('YYYY-MM-DD');
      await patchDatoDePagoDelEmpleado(formaDePago.id, formaDePago);
    }));
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = {
        ...form.getFieldsValue(),
      };

      let saved = false;
      const [key] = selectedRowKeys;

      const match = datosDePagosDeEmpleados.find((item) => item.id === key);
      const _datoDePagoDeEmpleado = await getDatoDePagoDelEmpleado(match.id);

      // Modificamos todos los registro anteriores activos para inactivarlo (si es modificación):
      const datosDePagosDeEmpleadosActivos = await getDatosDePagoDeEmpleados({ empleado: _datoDePagoDeEmpleado?.empleado, estados_globales: ESTATUS_ACTIVO }); // ESTATUS_ACTIVO = 1

      // Creamos un nuevo registro en base de datos al editarlo y ponemos estatus activo en caso de ser modificación:
      values.estados_globales = ESTATUS_ACTIVO;

      // Agregamos el metodo de pago METODO_DE_PAGO_TRANSFERENCIA_ELECTRONICA_DE_FONDOS: 3
      values.metodo_de_pago = METODO_DE_PAGO_TRANSFERENCIA_ELECTRONICA_DE_FONDOS;

      // Agregamos al empleado que lo asignaremos:
      values.empleado = _datoDePagoDeEmpleado?.empleado;

      // Finalmente guardamos el nuevo registro:
      saved = await postDatoDePagoDelEmpleado(values);

      if (saved) {
        await inactivarFormasDePagosDelEmpleado(datosDePagosDeEmpleadosActivos);
        if (_continue) {
          await fetchData();
          onClickEdit(saved);
        } else {
          onClickCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        form,
      );
    }
  };

  const resetearCamposForm = ({
    tipoDeposito = false,
    banco = false,
    numeroTarjeta = false,
    clabe = false,
  }) => {
    if (tipoDeposito) form.setFieldValue('tipos_de_depositos', null);
    if (banco) form.setFieldValue('banco', null);
    if (numeroTarjeta) form.setFieldValue('numero_tarjeta', null);
    if (clabe) form.setFieldValue('clabe', null);
  };

  const deshabilitarCampos = ({
    numeroTarjeta = false,
    clabe = false,
  }) => {
    setDeshabilitarNoCuenta(numeroTarjeta);
    setDeshabilitarCLABE(clabe);
  };

  const onChangeTipoDeposito = async (tipoDeposito) => {
    if (tipoDeposito === TIPO_DE_DEPOSITO_DEBITO) {
      resetearCamposForm({ clabe: true });
      deshabilitarCampos({ clabe: true });
      setValidateStatusCLABE('');
      form.validateFields(['clabe']);
    }

    if (tipoDeposito === TIPO_DE_DEPOSITO_CLABE) {
      resetearCamposForm({ numeroTarjeta: true });
      deshabilitarCampos({ numeroTarjeta: true });
      setValidateStatusNoCuenta('');
      form.validateFields(['numero_tarjeta']);
    }
  };

  const handleOnRowClick = (record) => {
    if (selectedRowKeys.includes(record.id)) {
      setSelectedRowKeys(selectedRowKeys.filter((id) => id !== record.id));
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleSelectAll = (selected, selectedRows, changeRows) => {
    setSelectedRowKeys(selectedRows.map((row) => row.id));
  };

  const rowSelection = {
    selectedRowKeys,
    onSelectAll: handleSelectAll,
    type: 'checkbox',
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    numero_tarjeta: [
      {
        validator: async (rule, value) => {
          const numeroEnteroBooleano = (/^\d+$/.test(value));
          if (value?.length < 1 || !value) {
            return;
          }
          if (!numeroEnteroBooleano) {
            throw new Error('Solo se permiten números.');
          }
          if (value?.length < 12 || value?.length > 18) {
            throw new Error('El valor debe ser entre 12 a 18 digitos.');
          }
        },
      },
    ],
    CLABE: [
      {
        validator: async (rule, value) => {
          const numeroEnteroBooleano = (/^\d+$/.test(value));
          if (value?.length < 1 || !value) {
            return;
          }
          if (!numeroEnteroBooleano) {
            throw new Error('Solo se permiten números.');
          }
          if (value?.length !== 18) {
            throw new Error('El valor debe ser de 18 digitos.');
          }
        },
      },
    ],
  };

  const validateSonNumeros = (value) => {
    const numeroEnteroBooleano = (/^\d+$/.test(value));
    if (!numeroEnteroBooleano) {
      return false;
    }
    return true;
  };

  const onChangeNoCuenta = (event) => {
    // Se quita el indicador de requerido en CLABE:
    setValidateStatusCLABE('');

    // Si el texto ingresado es mayor a 0, deshabilitamos el campo de CLABE:
    if (event?.target?.value?.length > 0) {
      form.setFieldValue('clabe', null);
      setDeshabilitarCLABE(true);
    }

    // Validamos que sea un valor de numero de cuenta, entre 12 a 16 digitos, si no, marcamos como error:
    if (event?.target?.value?.length >= 12 && event?.target?.value?.length <= 16) {
      setValidateStatusNoCuenta('success');
    } else {
      setValidateStatusNoCuenta('error');
    }

    // Validamos que lo ingresado sean solo números:
    if (!validateSonNumeros(event?.target?.value)) {
      setValidateStatusNoCuenta('error');
    }

    form.validateFields();
  };

  const onChangeCLABE = (event) => {
    // Se quita el indicador de requerido en No. de Cuenta:
    setValidateStatusNoCuenta('');

    // Si el texto ingresado es mayor a 0, deshabilitamos el campo de No. De cuenta:
    if (event?.target?.value?.length > 0) {
      form.setFieldValue('noCuenta', null);
      setDeshabilitarNoCuenta(true);
    }

    // Validamos que sea un valor de CLABE, de 18 digitos, si no, marcamos como error:
    if (event?.target?.value?.length === 18) {
      setValidateStatusCLABE('success');
    } else {
      setValidateStatusCLABE('error');
    }

    // Validamos que lo ingresado sean solo números:
    if (!validateSonNumeros(event?.target?.value)) {
      setValidateStatusCLABE('error');
    }

    form.validateFields();
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={datosDePagosDeEmpleados}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickEdit,
            onClickDelete,
            onClickDeactivate,
          }}
          deleteText="Limpiar Datos Bancarios"
          permission={permission}
          allowImport
          allowDeactivate
          allowDoubleClick={false}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          footer={null}
          width={500}
          title={(
            <FormSubmitControls
              label="Asignación de Banco"
              onFinish={onFinish}
              onCancel={onClickCancel}
              loading={loading}
            />
          )}
          onCancel={onClickCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
          >
            <Row gutter={10}>
              <Col span={24}>
                <Form.Item
                  name="tipos_de_depositos"
                  label="Tipo de Depósito"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    keyProp="id"
                    labelProp="concepto"
                    dataSource={tiposDeDepositos}
                    onChange={onChangeTipoDeposito}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={30}>
                <Form.Item
                  name="banco"
                  label="Banco"
                  hasFeedback
                  rules={rules.required}
                >
                  <Select
                    keyProp="id"
                    labelProp="nombre"
                    dataSource={bancos}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24} md={30}>
                <Form.Item
                  name="numero_tarjeta"
                  label="No. de Cuenta"
                  hasFeedback
                  rules={[rules.numero_tarjeta[0], deshabilitarNoCuenta ? [] : requiredRule]}
                  validateStatus={validateStatusNoCuenta}
                >
                  <Input
                    onChange={onChangeNoCuenta}
                    disabled={deshabilitarNoCuenta}
                    minLength={12}
                    maxLength={18}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24} md={30}>
                <Form.Item
                  name="clabe"
                  label="CLABE"
                  hasFeedback
                  rules={[rules.CLABE[0], deshabilitarCLABE ? [] : requiredRule]}
                  validateStatus={validateStatusCLABE}
                >
                  <Input
                    onChange={onChangeCLABE}
                    disabled={deshabilitarCLABE}
                    maxLength={18}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
        <ModalLimpiar
          onDelete={onDelete}
          onCancel={() => setOpenDelete(false)}
          open={openDelete}
          content={selectedRowKeys.length === 1 ? 'Dato Bancario Seleccionado' : `${deleteMessage} Datos Bancarios Seleccionados`}
          loading={loading}
        />
        <ModalDeactivate
          onDeactivate={onDeactivate}
          onCancel={() => setOpenDeactivate(false)}
          open={openDeactivate}
          content={selectedRowKeys.length === 1 ? 'Forma de Pago Seleccionado' : `${deleteMessage} Formas de Pagos Seleccionados`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default AdministracionDeTarjetasDePago;
